export default "__VITE_ASSET__Cp7K15Va__"